import { signInUser } from "../firebase/auth";
import React, { useEffect, useState } from "react";
import { login } from "../utils/api";
import { useNavigate } from "react-router-dom";
import { useLoading } from "./Loading";
import { useAuth } from "../contexts/authContext";

function Login()
{
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const {setLoading} = useLoading();
    const {currentUser, role} = useAuth();

    useEffect(()=>{
        setTimeout(() => {
            setLoading(false);
        }, 10);
        if(currentUser)
        {
            navigate('/');
        }
    },[])
    
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            await login({email});
            const userCredential = await signInUser(email, password);
            const user = userCredential.user;
            const updatedIdTokenResult = await user.getIdTokenResult();
            
            setLoading(false);
            // alert("Login Successful");

            if(updatedIdTokenResult.claims.role === "shelter")
            {
                navigate("/shelter-dashboard");
            }
            else{
                navigate("/");
            }
           
        }
        catch (error) {
            setLoading(false);
            console.log(error);
            if(error.message==="Firebase: Error (auth/invalid-credential).")
            {
                alert("Invalid email or password");
            }
            else
            {
                alert(`${error.message}`);
            }
            
        }
    };

    return (
        <div className="loginContainer">
            <div className="loginForm">
                <h1>Sign In</h1>
                <form onSubmit={handleLogin}>
                    <input type="email" className="loginBox" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    <input type="password" className="loginBox" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <button type="submit">Login</button>
                </form>
                <div className="registerForgot">
                    <a href="/forgot-password">Forgot password?</a>
                    <p>Don't have an account? <a href="/register">Register</a></p>
                </div>
            </div>
        </div>
    )
}

export default Login;
